import { render, staticRenderFns } from "./DebtorList.vue?vue&type=template&id=19428ff4&scoped=true&"
import script from "./DebtorList.vue?vue&type=script&lang=js&"
export * from "./DebtorList.vue?vue&type=script&lang=js&"
import style0 from "./DebtorList.vue?vue&type=style&index=0&id=19428ff4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19428ff4",
  null
  
)

export default component.exports